(function() {
    'use strict';

    angular
        .module('app')
        .directive('member', member);

    member.$inject = ['$compile', '$timeout'];
    
    function member($compile, $timeout) {
        // Usage:
        //     <member></member>
        // Creates:
        // 
        return {
            restrict: "E",
            replace: true,
            scope: {
                member: '=',
                onClicked: '=',
                showFolder: '=',
                mode: '='
            },
            template: '<div class="tree-node"><i ng-if="member.icon" ng-show="member.children.length>0 ' +
                '&& !member.expanded" ng-click="expand()" class="fa fa-plus-square-o" aria-hidden="true"></i> ' +
                '<span class="node-spacer" ng-show="!member.children"></span>' +
                '<i class="fa fa-minus-square-o" ng-show="member.expanded && member.children.length>0" ng-click="collapse()"></i> ' +
                "<div id='node{{member.uniqueId}}' ng-class=\"{ 'selected': member.selected } \" ng-dblclick=\"itemClicked(member, true, $event)\" ng-click=\"itemClicked(member, false, $event)\" class=\"node-item\">" +
                '<span ng-if="member.icon.length > 0"><img ng-if="member.icon" ng-class=\"{ \'large-icon\': member.largeIcon }" src="{{member.icon}}"/></span>' +
                "    <span ng-if='mode != 1'>{{member.name}}</span><span ng-if='mode == 1'><span ng-hide='showFolder && !member.vaultType'>{{member.name}}</span><span ng-show='showFolder && !member.vaultType'>{{member.folder}}</span></span></div></div>",
            link: function (scope, element, attrs) {
                var alreadyClicked = false;
                scope.itemClicked = function (item, doubleClick, event) {
                    //ignore vaults.
                    if (item.vaultType) {
                        return;
                    }
                    if (!alreadyClicked) {
                        alreadyClicked = true;
                        scope.onClicked(item, doubleClick, event);
                        $timeout(function () {
                            alreadyClicked = false;
                        }, 500);
                    }
                    if (doubleClick) {
                        scope.onClicked(item, doubleClick, event);
                    }
                }
                if (scope.member.expanded && angular.isArray(scope.member.children)) {
                    if (element[0].getElementsByClassName("collection").length == 0) {
                        element.append("<div class='collection' ng-show='member.expanded'><collection mode='mode' show-folder='showFolder' collection='member.children' on-clicked='itemClicked'></collection></div>");
                        childScope = scope.$new();
                        $compile(element.contents())(scope);
                    }
                    
                }

                var childScope;
                scope.expand = function () {
                    scope.member.expanded = true;
                    if (element[0].getElementsByClassName("collection").length == 0) {
                        element.append("<div class='collection' mode='mode' ng-show='member.expanded'><collection show-folder='showFolder' mode='mode' collection='member.children' on-clicked='itemClicked'></collection></div>");
                        //childScope = scope.$new();
                        $compile(element.contents())(scope);
                    }
                                      
                }
                scope.collapse = function () {
                    scope.member.expanded = false;
                    var cleanUp = function (children) {
                        angular.forEach(children, function (item, key) {
                            item.expanded = false;
                            if (angular.isArray(item.children)) {
                                cleanUp(item.children);
                            }
                        })
                    }

                    //angular.element(element[0].getElementsByClassName('tree-node')).remove();

                    cleanUp(scope.member.children);
                    //childScope.$destroy();
                }

            }
        }
    }

})();